import { ActivationStart } from '@angular/router';
import * as i0 from "@angular/core";
import * as i1 from "@angular/router";
export class ThemeService {
    constructor(router) {
        this.router = router;
        this.enableThemeSwitchingByRoute();
    }
    enableThemeSwitchingByRoute() {
        this.router.events.subscribe(event => {
            if (event && event instanceof ActivationStart && event.snapshot && event.snapshot.url && event.snapshot.url.length > 0) {
                if (event.snapshot.data && event.snapshot.data.theme) {
                    this.themeName = event.snapshot.data.theme;
                    if (this.themeName === 'glo') {
                        this.setTheme('assets/glo.css');
                    }
                    else {
                        this.setTheme('assets/theme.css');
                    }
                }
            }
        });
    }
    setTheme(themePath) {
        const currentThemePath = this.getLinkElement().getAttribute('href');
        if (currentThemePath !== themePath) {
            this.getLinkElement().setAttribute('href', themePath);
        }
    }
    /**
     * Remove the stylesheet with the specified key.
     */
    removeStyle(key) {
        const existingLinkElement = this.getExistingLinkElement();
        if (existingLinkElement) {
            document.head.removeChild(existingLinkElement);
        }
    }
    getLinkElement() {
        return this.getExistingLinkElement() || this.createLinkElement();
    }
    getExistingLinkElement() {
        return document.head.querySelector(`link[rel="stylesheet"].${this.getClassName()}`);
    }
    createLinkElement() {
        const linkEl = document.createElement('link');
        linkEl.setAttribute('rel', 'stylesheet');
        linkEl.classList.add(this.getClassName());
        document.head.appendChild(linkEl);
        return linkEl;
    }
    getClassName() {
        return `style-manager-theme`;
    }
}
ThemeService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ThemeService_Factory() { return new ThemeService(i0.ɵɵinject(i1.Router)); }, token: ThemeService, providedIn: "root" });
